import type { FC } from 'react'
import { IkyuRestaurantLogo, PaypayGourmetLogo } from '~/components/logos'
import { css } from '~/styled-system/css'
import { center } from '~/styled-system/patterns'
import { HeaderWrapper } from '../HeaderWrapper'

const ErrorHeader: FC = () => {
  return (
    <HeaderWrapper>
      <header className={center({ borderBottom: 'medium', p: '3' })}>
        <a href="/" className={css({ display: 'inline-block' })}>
          <ErrorLogo />
        </a>
      </header>
    </HeaderWrapper>
  )
}

const ErrorLogo: FC = import.meta.env.VITE_MODE === 'ppg' ? PaypayGourmetLogo : IkyuRestaurantLogo

export default ErrorHeader
